import { OrderOperationType } from 'api/types/entity';
import { VerificationCodeFormContentDialog } from 'components';
import { useTranslation } from 'libs/i18n';
import { Typography } from 'libs/ui';

import { DialogDocumentsStyled } from './styles';

interface Props<Values extends object> {
  isOpen: boolean;
  onClose: () => void;
  codeFieldName: Extract<keyof Values, string>;
  orderType: OrderOperationType;
  codeLength?: number;
}

export const DialogVerificationCode = <Values extends object>({
  isOpen,
  onClose,
  codeFieldName,
  orderType,
  codeLength = 6,
}: Props<Values>) => {
  const { t } = useTranslation();

  return (
    <VerificationCodeFormContentDialog<Values>
      codeFieldName={codeFieldName}
      isOpen={isOpen}
      length={codeLength}
      onClose={onClose}
    >
      <DialogDocumentsStyled spacing={8} spacingMobile={4}>
        <Typography variant="bodyBold" variantMobile="captionBold">
          {t(`account.createOrder.dialogVerification.content.title`)}
        </Typography>
        <ul>
          <li>
            <Typography variantMobile="caption">
              {t(`account.createOrder.dialogVerification.content.text`, {
                type: t(`account.order.types.${orderType}`),
              })}
            </Typography>
          </li>
        </ul>
      </DialogDocumentsStyled>
    </VerificationCodeFormContentDialog>
  );
};
